export default "__VITE_ASSET__BRL7_Ysc__"